module.exports = __webpack_public_path__ + "static/img/female-bg-fr.0a770ac7.png";